/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Dutch (Netherlands)
export default {
  'fabric.reactions.add': 'Reactie toevoegen',
  'fabric.reactions.error.unexpected': 'Reacties zijn tijdelijk niet beschikbaar',
  'fabric.reactions.loading': 'Bezig met laden…',
  'fabric.reactions.more.emojis': "Meer emoji's",
  'fabric.reactions.other.reacted.users': '{count, plural, one {en één andere} other {en {count} andere}}',
  'fabric.reactions.reactwithemoji': 'Reageren met emoticon {emoji}',
  'fabric.reactions.summary': 'Alle reacties van gebruikers bekijken',
  'reaction-picker-trigger.add.reaction.message': 'Voeg een reactie toe',
  'reactions.dialog.close': 'Sluiten',
  'reactions.dialog.emoji.name': '{emojiName}',
  'reactions.dialog.left.navigate': 'Navigeer naar links',
  'reactions.dialog.reactions.count':
    '{count, plural, one {{count,number} totale reactie} other {{count,number} totale reacties}}',
  'reactions.dialog.right.navigate': 'Navigeer naar rechts',
  'reactions.dialog.viewall': 'Alles bekijken',
  'reactions.dialog.viewall.tooltip': 'Alle reacties van gebruikers bekijken',
};
